// Format a number with thousands separators.
export const fmtNum = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  const v = typeof n === "string" ? Number(n) : n;
  if (Number.isNaN(v)) return "—";
  return v.toLocaleString("en-US");
};

// "pts" or "mi"
export const fmtBalance = (n, currency = "pts") => `${fmtNum(n)} ${currency}`;

// Best "last synced at" timestamp for a program. Legacy sync runs write
// sync.last_check_at; the ReservoirAI extension writes scraped_at on the
// program itself. Prefer whichever is newer.
export const lastSyncedAt = (p) => {
  if (!p) return null;
  const a = p.sync?.last_check_at || null;
  const b = p.scraped_at || null;
  if (a && b) return new Date(a) > new Date(b) ? a : b;
  return a || b;
};

// The number to show / sum for a program. When pooled_balance is present
// (e.g. United Miles Pooling — pool owner's account), the pooled value IS
// the redeemable total — it replaces the individual balance, not adds to it.
export const effectiveBalance = (p) =>
  (p && p.pooled_balance != null && p.pooled_balance > 0)
    ? p.pooled_balance
    : (p?.balance || 0);

export const sumBy = (arr, fn) => arr.reduce((a, b) => a + (Number(fn(b)) || 0), 0);

// Returns a category for a row of "Use this now"
export const urgencyClass = (u) =>
  u === "urgent" ? "pill-bad" : u === "due" ? "pill-warn" : "pill-good";

export const dateLabel = (iso) => {
  if (!iso) return "no expiry";
  if (iso === "no expiry") return iso;
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
};

// Short relative timestamp: "Just now", "3m ago", "2h ago", "5d ago",
// or an absolute date if older than ~30d / invalid.
export const fmtRelative = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const secs = Math.floor((Date.now() - d.getTime()) / 1000);
  if (secs < 30) return "just now";
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};
